import {
    JsonRatingModelOptions,
    RatingModelOptions,
    RatingModelOptionsFromJson,
} from '../options/rating-model-options';
import { PrimitiveModel } from './primitive.model';

export class RatingModel extends PrimitiveModel {
    public constructor(
        name: string,
        public value = '',
        public options = new RatingModelOptions(),
    ) {
        super(name, value, options);
    }
}

export class RatingModelFromJson extends RatingModel {
    public constructor(data: JsonRatingModel) {
        super(data.name, data.value, new RatingModelOptionsFromJson(data.options));
    }
}

export interface JsonRatingModel {
    name: string;
    value: string;
    options: JsonRatingModelOptions;
}
